import React from 'react';
import { WHATSAPP_URL } from '../../constants';
import './FloatingWhatsApp.css';

function IconWhatsApp() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M20.52 3.48A11.91 11.91 0 0 0 12.01 0C5.39 0 0 5.39 0 12c0 2.11.55 4.17 1.59 5.99L0 24l6.19-1.62A11.94 11.94 0 0 0 12.01 24C18.63 24 24 18.61 24 12a11.9 11.9 0 0 0-3.48-8.52ZM12.01 22.05c-1.83 0-3.62-.49-5.18-1.43l-.37-.22-3.67.96.98-3.57-.24-.37A10.03 10.03 0 0 1 1.95 12c0-5.55 4.52-10.06 10.06-10.06 2.69 0 5.21 1.05 7.11 2.95a10 10 0 0 1 2.95 7.11c0 5.55-4.51 10.05-10.06 10.05Zm5.52-7.53c-.3-.15-1.77-.87-2.05-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.06-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.5h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.49 0 1.47 1.07 2.89 1.22 3.09.15.2 2.11 3.22 5.11 4.51.71.31 1.26.49 1.69.62.71.23 1.36.2 1.87.12.57-.09 1.77-.72 2.02-1.42.25-.7.25-1.3.17-1.42-.07-.12-.27-.2-.57-.35Z" />
    </svg>
  );
}

function FloatingWhatsApp() {
  return (
    <a
      className="floating-whatsapp"
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      title="Chat on WhatsApp"
    >
      <IconWhatsApp />
    </a>
  );
}

export default FloatingWhatsApp;

